// src/pages/user/authentication/AuthPage.jsx
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import MyNavbar from '../../../components/user/general/mynavbar/MyNavbar.js';
import LoginForm from '../../../screens/user/authentication/login/Login.js';
import RegisterForm from '../../../screens/user/authentication/register/Register.js';
import "../../../assets/css/user/authentication/Auth.css";

const Auth = () => {
  const location = useLocation();

  const [isLogin, setIsLogin] = useState(
    location.state?.isLogin ?? true
  );
  const [pendingCredentials, setPendingCredentials] = useState(null);

  const handleRegisterSuccess = (email, password) => {
    setPendingCredentials({ email, password });
    setIsLogin(true);
  };

  return (
    <>
      <MyNavbar />
      <div className="auth-page">

        <div className="background-pattern">
          <svg
            className="pattern-svg"
            viewBox="0 0 600 600"
            preserveAspectRatio="xMidYMid slice"
          >
            {/* ===== Large Tractor Wheel (Top Left) ===== */}
            <circle cx="120" cy="120" r="90" className="wheel ring-1" />
            <circle cx="120" cy="120" r="70" className="wheel ring-2" />
            <circle cx="120" cy="120" r="50" className="wheel ring-3" />
            <circle cx="120" cy="120" r="30" className="wheel ring-4" />

            <line x1="120" y1="30" x2="120" y2="210" className="spoke" />
            <line x1="30" y1="120" x2="210" y2="120" className="spoke" />
            <line x1="56" y1="56" x2="184" y2="184" className="spoke-light" />
            <line x1="184" y1="56" x2="56" y2="184" className="spoke-light" />

            {/* ===== Small Wheel (Bottom Right) ===== */}
            <circle cx="480" cy="480" r="60" className="wheel small-1" />
            <circle cx="480" cy="480" r="45" className="wheel small-2" />
            <circle cx="480" cy="480" r="30" className="wheel small-3" />

            <line x1="480" y1="420" x2="480" y2="540" className="spoke-light" />
            <line x1="420" y1="480" x2="540" y2="480" className="spoke-light" />

            {/* ===== Decorative Curves ===== */}
            <path
              d="M 50,300 Q 150,280 250,300 T 450,300"
              className="decor-line strong"
            />
            <path
              d="M 100,400 Q 200,380 300,400 T 500,400"
              className="decor-line soft"
            />
          </svg>
        </div>

        <div className={`auth-card ${!isLogin ? "register-active" : ""}`}>

          {/* ===== LEFT YELLOW PANEL ===== */}
          <div className="side-panel">
            <div className="panel-content">
              {isLogin ? (
                <>
                  <h2>Welcome Back!</h2>
                  <p>Already have an account?</p>
                  <button onClick={() => setIsLogin(false)}>
                    Register
                  </button>
                </>
              ) : (
                <>
                  <h2>Hello, Welcome!</h2>
                  <p>Don't have an account?</p>
                  <button onClick={() => setIsLogin(true)}>
                    Login
                  </button>
                </>
              )}
            </div>
          </div>

          {/* ===== RIGHT FORM PANEL ===== */}
          <div className="form-panel">

            {/* LOGIN FORM */}
            {isLogin && (
              <LoginForm
                autoLoginCredentials={pendingCredentials}
                onAutoLoginHandled={() => setPendingCredentials(null)}
              />
            )}

            {/* REGISTER FORM */}
            {!isLogin && <RegisterForm onRegisterSuccess={handleRegisterSuccess} />}

          </div>
        </div>
      </div>
    </>
  );
};

export default Auth;